module.exports = __webpack_public_path__ + "img/haidao.3c14be46.png";